// src/router/clientes.js

// Quem abre estas telas (TRI-107; o admin passa). Aplicado pelo guard de @/router/permissoes.js,
// que o menu lateral também usa.
const ROLES = ['colaborador_prana', 'colaborador_satya']

const clientesBreadCrumb = [
    {
        label: 'Home',
        to: 'Home'
    },
    {
        label: 'Clientes',
        to: 'Clientes'
    }
]

export default [
    {
        path: '/clientes',
        name: 'Clientes',
        component: () => import('@/views/Clientes/ClienteListPage.vue'),
        meta: {
            roles: ROLES,
            title: 'Clientes',
            breadcrumb: clientesBreadCrumb
        },
    },
    {
        path: '/clientes/novo',
        name: 'ClienteNovo',
        component: () => import('@/views/Clientes/NovoClientePage.vue'),
        meta: {
            roles: ROLES,
            title: 'Novo Cliente',
            breadcrumb: [
                ...clientesBreadCrumb,
                {
                    label: 'Novo Cliente',
                    to: 'ClienteNovo'
                }
            ]
        }
    },
    {
        path: '/clientes/:id/detalhes',
        name: 'ClienteDetalhes',
        component: () => import('@/views/Clientes/NovoClientePage.vue'),
        meta: {
            roles: ROLES,
            title: 'Detalhes do Cliente',
            breadcrumb: [
                ...clientesBreadCrumb,
                {
                    label: 'Detalhes do Cliente',
                    to: 'ClienteNovo'
                }
            ]
        }
    }
];
